module.exports = __webpack_public_path__ + "img/astral_14.c22e1a01.svg";